export default class ProjectsViewState extends Backbone.Model
  defaults:
    addProjectInProgress: false
    addSkillsMode: false
    addTopicsMode: false



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/models/projects_view_state.js.coffee